module.exports = __webpack_public_path__ + "img/aiSend.f3cbb448.png";